import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'sz-num-big',
  templateUrl: './sz-num-big.component.html',
  styleUrls: ['./sz-num-big.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzNumBigComponent {
  readonly value: InputSignal<string | number> = input.required<string | number>();
  readonly unit: InputSignal<string | null> = input<string | null>(null);
}
